import { baseUrl } from '../../utils/constants';
import { client } from '../client';
import {
  CREATEGROUPBYRANK,
  CREATEGROUPBYROLE,
  GETALLGROUPDETAILS,
  GROUPS,
} from '../endpoints';

export const getAllGroups = async ({
  page,
  size,
  q,
}: {
  page: number;
  size: number;
  q: string;
}) => {
  const response = await client.get(`${baseUrl}${GETALLGROUPDETAILS}`, {
    params: {
      page,
      size,
      q,
    },
  });
  return response;
};

export const removeGroup = async (groupId: number) => {
  const response = await client.delete(`${baseUrl}${GROUPS}/${groupId}`);
  return response;
};

export const getGroupDetails = async (groupId: number) => {
  const response = await client.get(`${baseUrl}${GROUPS}/${groupId}/details`);
  return response;
};

export const getUpdatedGroup = async ({
  groupName,
  memberUserIds,
  groupId,
}: {
  groupName: string;
  memberUserIds: number[];
  groupId: number;
}) => {
  const response = await client.put(`${baseUrl}${GROUPS}/${groupId}/update`, {
    groupName,
    memberUserIds,
    groupId,
  });
  return response;
};

export const createGroupByRole = ({
  roleId,
  groupName,
}: {
  roleId: number;
  groupName: string;
}) => {
  const response = client.post(`${baseUrl}${CREATEGROUPBYROLE}`, {
    groupName,
    roleId,
  });
  return response;
};

export const createGroupByRank = ({
  rankId,
  groupName,
}: {
  rankId: number;
  groupName: string;
}) => {
  const response = client.post(`${baseUrl}${CREATEGROUPBYRANK}`, {
    groupName,
    rankId,
  });
  return response;
};
